"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IlErrorBoundaryWithBrandAndNotifications = exports.IlErrorBoundaryWithBrandErrors = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("../../components");
var static_texts_1 = require("../../configs/static-texts");
var enums_1 = require("../../shared/enums");
var brand_provider_1 = require("../brand/brand.provider");
var il_snackbar_notifications_provider_1 = __importDefault(require("../il-snackbar-provider/il-snackbar-notifications.provider"));
var il_error_boundary_1 = require("./il-error-boundary");
function IlErrorBoundaryWithBrandErrors(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var brandState = react_1.default.useContext(brand_provider_1.BrandContext);
    var brand = (brandState === null || brandState === void 0 ? void 0 : brandState.brand) || enums_1.BrandEnum.MONARCH;
    return (react_1.default.createElement(il_error_boundary_1.ILErrorBoundary, __assign({ customMessage: react_1.default.createElement(components_1.IlErrorBanner, { color: enums_1.ColorPaletteEnum.ERROR, title: "We ran into a problem while trying to load this page. Please try again later.", description: react_1.default.createElement("p", null, static_texts_1.staticTextsWithBrand.errorMessage[brand]) }) }, props), children));
}
exports.IlErrorBoundaryWithBrandErrors = IlErrorBoundaryWithBrandErrors;
function IlErrorBoundaryWithBrandAndNotifications(props) {
    return (react_1.default.createElement(il_snackbar_notifications_provider_1.default, null,
        react_1.default.createElement(IlErrorBoundaryWithBrandErrors, __assign({}, props))));
}
exports.IlErrorBoundaryWithBrandAndNotifications = IlErrorBoundaryWithBrandAndNotifications;
